import { t as ZepIcon } from "../ZepIcon-BjEF3k8i.mjs";
import { jsx } from "react/jsx-runtime";
//#region src/components/X.tsx
const XIcon = ZepIcon((props) => /* @__PURE__ */ jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ jsx("path", {
		d: "M5.293 5.293a1 1 0 0 1 1.414 0L12 10.586l5.293-5.293a1 1 0 1 1 1.414 1.414L13.414 12l5.293 5.293a1 1 0 0 1-1.414 1.414L12 13.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L10.586 12 5.293 6.707a1 1 0 0 1 0-1.414Z",
		fill: props.fill || "currentColor"
	})
}));
//#endregion
export { XIcon };
